import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Arithon from "../../Assets/Projects/Arithon.png";
import FolioAbhinav from "../../Assets/Projects/Folio-Abhinav.png";
import TestpadSolutions from "../../Assets/Projects/TestpadSolutions.png";
import AcroLens from "../../Assets/Projects/AcroLens.png";
import HourCast from "../../Assets/Projects/HourCast.png";
import RaitaLeaks from "../../Assets/Projects/RaitaLeaks.png";
import ProTrack from "../../Assets/Projects/ProTrack.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          A collection of work from my recent builds.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AcroLens}
              isBlog={false}
              title="AcroLens"
              description="An intelligent document workbench designed to analyze PDFs, extract AI-powered insights, and generate podcast-style audio summaries for a seamless research experience."
              ghLink="https://github.com/abhinavrathee/Adobe-Round3.git"
              //demoLink="https://AcroLens-49.web.app/"
              techstack={["Reactjs", "FastAPI", "Gemini-AI", "Adobe-API", "Tailwind-CSS", "Docker"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RaitaLeaks}
              isBlog={false}
              title="RaitaLeaks"
              description="A secure, real-time MERN platform for whistleblowing and information sharing. Features media-rich posts, authenticated profiles, and instant notifications in a sleek, responsive UI."
              ghLink="https://github.com/abhinavrathee/RaitaLeaks.git"
              demoLink="https://raita-leaks.vercel.app/"
              techstack={["React", "Nodejs", "MongoDB", "Websockets", "JWT-Authentication", "MERN-Stack", "Cloudinary"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TestpadSolutions}
              isBlog={false}
              title="Testpad-Solutions"
              description="The project serves as a centralized collection of university-level course materials. It includes source code implementations, detailed assignments, visual references (screenshots), and documentation for fundamental CS subjects."
              ghLink="https://github.com/abhinavrathee/Testpad-Solutions.git"
              // demoLink="https://editor.soumya-jit.tech/"
              techstack={["HTML5", "C++", "Java", "SQL", "Shell", "Bash"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Arithon}
              isBlog={false}
              title="Arithon"
              description="A clean and responsive calculator app built with React and Tailwind CSS, focused on clarity, precision, and smooth usability."
              ghLink="https://github.com/abhinavrathee/Arithon.git"
              demoLink="https://arithon.vercel.app/"
              techstack={["Reactjs", "Calculator", "Tailwind-CSS", "Lucide-React"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={HourCast}
              isBlog={false}
              title="HourCast"
              description="A sleek, minimal digital clock and weather dashboard designed for modern browsers. Built with React and Tailwind CSS, it features a clean grey-and-black interface with a focus on responsiveness, performance, and a distraction-free user experience."
              ghLink="https://github.com/abhinavrathee/HourCast.git"
              demoLink="https://hour-cast.vercel.app/"
              techstack={["React", "Weather-Api", "Tailwind-CSS", "Responsive-Design", "Digital-Clock"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FolioAbhinav}
              isBlog={false}
              title="Folio-Abhinav"
              description="A personal portfolio website featuring multi-page layout, project showcases, resume, and technical skills. Built with React.js and Express.js, it is fully responsive and styled with React-Bootstrap and CSS for easy customization."
              ghLink="https://github.com/abhinavrathee/Folio-AbhinavRathee.git"
              demoLink="https://abhinaver.is-a.dev/"
              techstack={["Reactjs", "Nodejs", "Expressjs", "CSS3"]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ProTrack}
              isBlog={false}
              title="ProTrack-Dashboard"
              description="A web-based productivity and project management platform for individuals and teams. ProTrack offers interactive dashboards, activity tracking, goal setting, analytics, and reports in a sleek, responsive UI—enabling users to manage tasks, track progress, and customize their workflow."
              ghLink="https://github.com/abhinavrathee/ProTrack.git"
              demoLink="https://abhinavrathee.github.io/ProTrack/"
              techstack={["HTML5", "CSS3", "JavaScript", "Dashboard", "Responsive-Ui"]}
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
